import { render, staticRenderFns } from "./DebitPriceDescriptor.vue?vue&type=template&id=2145068e&scoped=true&"
import script from "./DebitPriceDescriptor.vue?vue&type=script&lang=js&"
export * from "./DebitPriceDescriptor.vue?vue&type=script&lang=js&"
import style0 from "./DebitPriceDescriptor.vue?vue&type=style&index=0&id=2145068e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2145068e",
  null
  
)

export default component.exports